export default {
    computed: {
        store: function () {
            return this.dataStore.getStore()
        }
    }
}